import { APP_BASE_URL, APP_TITLE, iconUrl } from './config/env';

const HostConfig = {
  icon: iconUrl('apple-touch-icon.png'),
  uri: APP_BASE_URL.endsWith('/') ? APP_BASE_URL : `${APP_BASE_URL}/`,
  title: APP_TITLE,
};
export default HostConfig;
